import type {ReactElement} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import type {WizardDesignActionsProps} from './wizard-design-actions.types';
import {PremiumCrownChip} from '@Components/premium-crown-chip/premium-crown-chip';
import {doesPlanCapDesignsPerPost} from '@Libraries/social-media-wizard-design-library';
import {useWizardDesignActions} from './use-wizard-design-actions';
import styles from './wizard-design-actions.module.scss';

export function WizardDesignActions({
  onDesignsStaged,
  onEditDesign,
  onEmbeddedEditorOpened,
  isLoadingEmbeddedEditor,
  setIsPreviewLoading,
  setIsLoadingEmbeddedEditor,
}: WizardDesignActionsProps): ReactElement {
  const {onAddDesignClick} = useWizardDesignActions({onDesignsStaged, onEmbeddedEditorOpened, setIsPreviewLoading, setIsLoadingEmbeddedEditor});

  const getAddDesignPremiumCrownChip = (): ReactElement | null => {
    if (!doesPlanCapDesignsPerPost()) {
      return null;
    }

    return <PremiumCrownChip />;
  };

  const getAddDesignCta = (): ReactElement => {
    return (
      <div className={`_position-relative ${styles.addDesignCtaContainer}`}>
        <Button
          type={Type.SECONDARY}
          icon="icon icon-plus"
          size={Size.SMALL}
          customClasses={styles.designActionButton}
          text={window.i18next.t('pmwjs_add_design')}
          iconPlacement={IconPlacement.LEFT}
          onClick={onAddDesignClick}
        />
        {getAddDesignPremiumCrownChip()}
      </div>
    );
  };

  const getEditDesignCta = (): ReactElement => {
    return (
      <Button
        type={Type.SECONDARY}
        icon="icon icon-pencil"
        size={Size.SMALL}
        customClasses={styles.designActionButton}
        text={window.i18next.t('pmwjs_edit_design_capitalized')}
        iconPlacement={IconPlacement.LEFT}
        onClick={onEditDesign}
        isLoading={isLoadingEmbeddedEditor}
      />
    );
  };

  return (
    <div className={styles.designActionsBar}>
      {getAddDesignCta()}
      {getEditDesignCta()}
    </div>
  );
}
